import Skill from "components/Skill/Skill";
import { FunctionComponent } from "react";
import { IRosterSkill } from "types/Skill";
import S from "./styled";

type OwnProps = {
  skills: IRosterSkill[];
};

type Props = OwnProps;

const Skills: FunctionComponent<Props> = ({ skills }) => {
  const Skills = skills.sort((a, b) => b.rating - a.rating).map((skill) => <Skill data={skill} key={skill.name} />);

  return <S.Container>{Skills}</S.Container>;
};

export default Skills;
